import { apolloClient } from '~/apollo';
import { GET_ECG_HISTORY_LIST } from '~/graphql/queries';

export const getEcgHistoryList = async (params: {
  day: number;
  month: number;
  year: number;
  userId: string;
  isLatest?: boolean;
}): Promise<any> => {
  return apolloClient.query({
    query: GET_ECG_HISTORY_LIST,
    variables: {
      day: params.day,
      month: params.month,
      year: params.year,
      userId: params.userId,
      isLatest: params.isLatest ?? false,
    },
    fetchPolicy: 'network-only',
  });
};
